import { Grid, List, ListItem, ListItemAvatar, ListItemText, TextField } from '@mui/material';
import * as api from "api/Core";
import { GlobalClassKeys } from 'assets/jss/common-styles';
import { LoadingIndicator } from 'components/CallServer/LoadingIndicator';
import FilterResultText from 'components/FilterResultText';
import IconExternalLink from 'components/Icons/IconExternalLink';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import { GridEx } from 'components/MuiExtras/Grid/GridEx';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiLink from 'components/MuiExtras/MuiLink';
import { GenericListItemDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { getTopicSecondViewAction } from 'views/Timeline/Components/FeedHelpers';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    searchText: string;
    loading?: boolean,
    hasMore: boolean,
    topics: GenericListItemDto[],
    selectedItems: string[],
}

interface IProps {
    autoFocus?: boolean;
    onSelect: (data: GenericListItemDto) => void;
}

type Props = IProps & WithTranslation;

const TakeRecords = 10;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class SelectTopicsComponent extends React.Component<Props, IState> {

    private searchRef: any = null;
    private lastChange: number = 0;

    constructor(props: Props) {
        super(props);
        this.state = {
            topics: null,
            loading: null,
            hasMore: false,
            searchText: "",
            selectedItems: []
        };
    }

    ///
    static defaultProps = {
        autoFocus: false
    };

    ///
    private resetData() {
        this.setState({ topics: [], selectedItems: [], hasMore: false });
    }

    ///
    private getTopics(offset: number) {
        if (this.state.loading || !this.searchRef) return;

        const searchText: string = this.searchRef.value;

        this.setState({ loading: true });

        api.getTopicSelection(searchText, offset, TakeRecords + 1)
            .then((result) => {
                const hasMore = result.items.length == TakeRecords + 1;
                const newData = result.items.slice(0, TakeRecords);
                this.setState({ loading: false, topics: [...this.state.topics || [], ...newData], hasMore });
            })
            .catch(() => {
                this.setState({ loading: false, topics: [], hasMore: false });
            });
    }

    ///
    private handleSearch(e: React.KeyboardEvent<HTMLDivElement>) {
        if (e.keyCode == 13 && !this.state.loading) {
            this.lastChange = 0;
            this.resetData();
            this.getTopics(0);
        }
        else
            this.lastChange = new Date().getTime();
    }

    ///
    private renderList() {
        return (
            <>
                {this.state.loading && <LoadingIndicator />}

                {
                    !this.state.loading && this.state.topics && this.state.topics.length == 0 &&
                    <FilterResultText>{this.props.t("Common.Filter.EmptyRecordset")}</FilterResultText>
                }

                {
                    this.state.topics && this.state.topics.length > 0 &&
                    <List dense>
                        {
                            this.state.topics.map((v) => {
                                return (
                                    <ListItem
                                        style={{ cursor: "pointer" }}
                                        key={v.id}
                                        disableGutters
                                        disabled={this.state.selectedItems.includes(v.id)}
                                        onClick={
                                            () => {
                                                if (!this.state.selectedItems.includes(v.id)) {

                                                    this.props.onSelect(v);
                                                    this.setState({ selectedItems: this.state.selectedItems.concat([v.id]) });
                                                }
                                            }
                                        }
                                    >
                                        <ListItemAvatar>
                                            <img src={v.thumbnailUrl} width={32} height={32} alt={v.name} />
                                        </ListItemAvatar>

                                        <ListItemText
                                            primary={
                                                <Grid container>
                                                    <Grid item xs>
                                                        {v.name}
                                                    </Grid>
                                                    <Grid item>
                                                        <MuiLink onClick={getTopicSecondViewAction(v.id, true)}><IconExternalLink /></MuiLink>
                                                    </Grid>
                                                </Grid>
                                            }
                                            primaryTypographyProps={
                                                {
                                                    className: GlobalClassKeys.hoverHighlight
                                                }
                                            }
                                        />
                                    </ListItem>
                                );
                            })
                        }
                    </List>
                }

                {
                    this.state.hasMore &&
                    <MuiRegularButton
                        color="transparent"
                        simple
                        onClick={() => this.getTopics(this.state.topics.length)}
                    >
                        <span>{this.props.t("Common.Filter.LoadMore")}</span>
                    </MuiRegularButton>
                }

            </>
        );
    }

    ///
    public componentDidMount() {
        setInterval(() => {
            // Manipula sugestões após parar de teclar por 1s.
            if (this.lastChange > 0
                && !this.state.loading
                && (new Date().getTime() - this.lastChange) > 990) {

                this.lastChange = 0;

                this.resetData();

                if (this.state.searchText.length > 2)
                    this.getTopics(0);
            }
        }, 1000);

        this.getTopics(0);
    }

    ///
    public render() {
        const { autoFocus } = this.props;
        return (
            <MuiContainer>
                <GridEx container direction="column" fullHeight wrap="nowrap">
                    <GridEx item>
                        <TextField
                            autoFocus={autoFocus}
                            fullWidth
                            margin="normal"
                            placeholder={this.props.t("Common.Input.Placeholder.SearchByTitle")}
                            value={this.state.searchText}
                            onChange={() => this.setState({ searchText: this.searchRef.value })}
                            onKeyDown={(e) => this.handleSearch(e)}
                            inputRef={(ref) => this.searchRef = ref}
                        />
                    </GridEx>

                    <GridEx item grow={1} overflow="auto">
                        {this.renderList()}
                    </GridEx>
                </GridEx>
            </MuiContainer>
        );
    }
}

export const SelectTopics = withTranslation()(SelectTopicsComponent);